import { ClientSchemaType } from "../../validations/client";
    import { UPDATE_CLIENT } from "../../endpoints";
import makeAuthenticatedRequest from "../base-api";
import { IClient } from "../../types/brand";

export interface UpdateClientResponse {
  success: boolean;
  message?: string;
  client?: IClient;
}

export const updateClient = async (data: ClientSchemaType): Promise<UpdateClientResponse> => {
  const response = await makeAuthenticatedRequest(UPDATE_CLIENT, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to add client");
  }

  const result = await response.json();
  return result.data;
}; 